module.exports = __webpack_public_path__ + "img/ctrl-u-stub-mid-+i.ae3d8a13.svg";